if (!customElements.get("product-quantity")) {
  customElements.define(
    "product-quantity",
    class QuantityInput extends window.Component {
      constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((button) =>
          button.addEventListener("click", this.onButtonClick.bind(this))
        );
        this.querySelectorAll("button").forEach((button) =>
          button.classList.add("disabled")
        );
      }

      connectedCallback() {
        this.updateQuantityLimit();
        this.variantUpdateUnsubscriber = this.subscribeContext((state, previousState) => {
          if (
            state.variantSelected &&
            (!previousState.variantSelected ||
             state.variantSelected.id !== previousState.variantSelected.id)
          ) {
            this.setAttribute("data-variant-id", state.variantSelected.id);
            this.updateQuantityLimit();
          }
        });
      }

      disconnectedCallback() {
        if (this.variantUpdateUnsubscriber) {
          this.variantUpdateUnsubscriber();
        }
      }

      async updateQuantityLimit() {
        try {
          const cart = await window.getCart();
          const variantId = this.getAttribute("data-variant-id");
          
          let currentQuantity = 0;
          if (cart && cart.items) {
            const item = cart.items.find((item) => item.id == variantId);
            if (item) currentQuantity = item.quantity;
          }

          const nextElement = this.input.nextElementSibling;
          if (nextElement && nextElement.classList.contains('variant-inventory-data')) {
            const inventoryData = JSON.parse(nextElement.textContent.trim());
            if (inventoryData[variantId]) {
              this.input.setAttribute("max", inventoryData[variantId]);
              this.input.setAttribute("data-max", inventoryData[variantId]);
            }
          }

          let maxPerVariant = parseInt(this.input.getAttribute("data-max"));
          if (this.input.getAttribute("data-max") > 6 ) {
            maxPerVariant = 6;
          }
          
          const remaining = maxPerVariant - currentQuantity;
          if (this.input.getAttribute("data-max") < remaining) {
            this.input.setAttribute("max", this.input.getAttribute("data-max"));
          } else {
            this.input.setAttribute("max", remaining);
          }

          const formId = this.input.getAttribute("form");
          if (this.input.getAttribute("data-max") < 6) {
            $('#' + formId + ' .stock-alert-qview').html('재고가 '+this.input.getAttribute("data-max")+'장 남았습니다. 구매를 서둘러 주세요.');
          } else {
            $('#' + formId + ' .stock-alert-qview').html('');
          }

          
          if (remaining <= 0) {
            this.disableQuantityInput();
          } else if (this.input.getAttribute("max") == 1){
            $('#' + formId + ' .quantity__button[name="minus"]').each(function(index, element) {
              $(this).addClass('disabled');
            });
            $('#' + formId + ' .quantity__button[name="plus"]').each(function(index, element) {
              $(this).addClass('disabled');
            });
          } else {
            this.enableQuantityInput();
          }
        } catch (error) {
          console.error("Error updating quantity limit: ", error);
        }
      }

      onInputChange(e) {
        let value = parseInt(e.target.value.trim());
        if (value < 1) {
          value = 1;
          e.target.value = "1";
        }
        this.setContext("quantity", value);
        this.validateQtyRules();
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = parseInt(this.input.value);
        event.target.name === "plus"
          ? this.input.stepUp()
          : this.input.stepDown();

        if (previousValue !== parseInt(this.input.value)) {
          this.input.dispatchEvent(this.changeEvent);
          this.setContext("quantity", this.input.value);
        }
        this.validateQtyRules();
      }

      validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
          const min = parseInt(this.input.min);
          const buttonMinus = this.querySelector(
            ".quantity__button[name='minus']"
          );
          buttonMinus.classList.toggle("disabled", value <= min);
        }
        
        if (this.input.max) {
          const max = parseInt(this.input.max);
          const buttonPlus = this.querySelector(
            ".quantity__button[name='plus']"
          );
          buttonPlus.classList.toggle("disabled", value >= max);
        }
        
      }

      disableQuantityInput() {
        this.input.value = "0";
        this.input.disabled = true;
        const plusButton = this.querySelector("button[name='plus']");
        if (plusButton) {
          plusButton.disabled = true;
          plusButton.classList.add("disabled");
        }
      }

      enableQuantityInput() {
        this.setContext("quantity", 1);
        this.input.value = this.input.getAttribute("min") || "1";
        if(this.input.getAttribute("max") > 1) {
          this.input.disabled = false;
          const plusButton = this.querySelector("button[name='plus']");
          if (plusButton) {
            plusButton.disabled = false;
            plusButton.classList.remove("disabled");
          }
          const minusButton = this.querySelector("button[name='minus']");
          if (minusButton) {
            minusButton.disabled = false;
            minusButton.classList.remove("disabled");
          }
        }
        
      }
    }
  );
}